import React from "react";
import PropTypes from "prop-types";
import { FaEdit, FaTrash, FaEye, FaSyncAlt, FaTrashRestore, FaTrashAlt } from "react-icons/fa";
import { ActionButton, ButtonContainer } from "./TableActionButtons.styles";

// criar um botao para excluir definitivamente a gestante

const TableActionButtons = ({ onView, onEdit, onDelete, onUndelete, onResetPassword, isDisabled, showDelete, showUndelete, showExcluirGestante, onExcluirGestante, excluirGestanteDisabled }) => (
  <ButtonContainer>
    <ActionButton onClick={onView} disabled={isDisabled} title="Visualizar">
      <FaEye />
    </ActionButton>
    <ActionButton onClick={onEdit} disabled={showUndelete || isDisabled} title="Editar">
      <FaEdit />
    </ActionButton>
    {showDelete && <ActionButton onClick={onDelete} disabled={isDisabled} title="Desabilitar">
      <FaTrash />
    </ActionButton>}
    {showUndelete && <ActionButton onClick={onUndelete} disabled={isDisabled} title="Habilitar">
      <FaTrashRestore />
    </ActionButton>}
    {onResetPassword && (
      <ActionButton onClick={onResetPassword} disabled={showUndelete} title="Resetar Senha">
        <FaSyncAlt />
      </ActionButton>
    )}
    {showExcluirGestante && (
      <ActionButton onClick={onExcluirGestante} disabled={isDisabled || excluirGestanteDisabled} title="Excluir Gestante">
        <FaTrashAlt />
      </ActionButton>
    )}
  </ButtonContainer>
);

TableActionButtons.propTypes = {
  onView: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onResetPassword: PropTypes.func, 
  isDisabled: PropTypes.bool,
  showDelete: PropTypes.bool.isRequired,
  showUndelete: PropTypes.bool.isRequired,
  onExcluirGestante: PropTypes.func,
  showExcluirGestante: PropTypes.bool.isRequired,
  excluirGestanteDisabled: PropTypes.bool
};

TableActionButtons.defaultProps = {
  isDisabled: false,
  showDelete: true,
  showUndelete: false,
  showExcluirGestante: false,
  excluirGestanteDisabled: false
};

export default TableActionButtons;
